<div class="official-website-home-page">
  <div class="header-title">
    <h1><span>博世智能出行售后</span>全球领先的汽车技术服务提供商</h1>
    <p>我们为全球客户提供“配件、诊断及维修站服务”一站式服务解决方案，业务涵盖主机售后及独立售后市场，广泛应用于乘用车、商用车及非道路领域。</p>
  </div>
  <div class="home-carousel-container">
    <nz-carousel #myCarousel [nzEffect]="'fade'" [nzAutoPlay]="true">
      <div nz-carousel-content *ngFor="let item of carouselList">
        <div class="slide-container">
          <div class="slide-background" [ngStyle]="{'background-image': 'url(' + item.image + ')'}"></div>
          <div class="slide-overlay"></div>
          <div class="slide-content">
            <h2>{{item.title1}}<br>{{item.title2}}</h2>
            <p>{{item.text}}</p>
            <button *ngIf="item.needBtn" (click)="openExternalLink()">{{item.button}}</button>
          </div>
        </div>
      </div>
    </nz-carousel>
    <div class="carousel-switch-button">
      <img src="assets/official-website/carousel-left.png" class="arrow-image" (click)="goPre(myCarousel)">
      <img src="assets/official-website/carousel-right.png" class="arrow-image-right" (click)="goNext(myCarousel)">
    </div>
  </div>

  <div class="business-content">
    <div class="business-left">
      <img src="assets/official-website/spare-parts.png" alt="Spare Parts Image">
    </div>

    <div class="business-right">
      <h3>博世汽车配件</h3>
      <h1>配件查询电子目录</h1>
      <p>博世提供全系列汽车配件产品解决方案，从燃油车到新能源车，从商用车到非道路，从独立售后到主机售后，我们均有复合您需求的产品解决方案。
      </p>
      <button class="mt-6 px-4 py-2 border hover:bg-blue-100 business-button" (click)="openExternalLink(0)">一键查询</button>
    </div>
  </div>

  <div class="business-content">
    <div class="business-right mx:hidden">
      <img src="assets/official-website/services.png" alt="Spare Parts Image">
    </div>
    <div class="business-left">
      <h3>博世维修站服务</h3>
      <h1>维修站网络生态系统</h1>
      <p>博世提供多维度的维修站网络概念，从eXtra增值计划到博世配件优选及博世配件质选，再到具有强大品牌力的博世车联及博世柴油系统服务网络，满足您不同的发展需求。
      </p>
      <button class="mt-6 px-4 py-2 border hover:bg-blue-100 business-button" (click)="openExternalLink(1)">了解更多</button>
    </div>
    <div class="business-right sm:hidden">
      <img src="assets/official-website/services.png" alt="Spare Parts Image">
    </div>
  </div>

  <div class="business-content">
    <div class="business-left">
      <img src="assets/official-website/banner5.JPG" alt="Spare Parts Image">
    </div>

    <div class="business-right">
      <h3>博世车联</h3>
      <h1>专属中国市场的特许加盟经营品牌</h1>
      <p>博世车联提供“专业维修”、 “技术维修”、 “综合维修”赋能，用成熟的运营管理经验与高标准的质量体系帮助加盟商提升门店整体服务水准、盈利水平与面向未来的业务拓展能力。
      </p>
      <button class="mt-6 px-4 py-2 border hover:bg-blue-100 business-button" (click)="openExternalLink(2)">即刻加盟</button>
    </div>
  </div>
  <div class="further-topic-content">
    <h2 class="further-topic-title">更多资讯</h2>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 further-topic-cards">

      <!-- Contact Card -->
      <div class="bg-gray-100 overflow-hidden contact-card">
        <img src="assets/official-website/contact.png" alt="Contact" class="w-full h-48 object-cover">
        <a class="further-topic-click-field hover:text-black" href="/gb/cn/contact">
          <h3 class="further-topic-sub-title">联系我们</h3>
          <div class="further-topic-learn-more">
            <p>了解更多</p><img src="assets/official-website/arrow-right.png" class="arrow-image">
          </div>
        </a>
      </div>

      <!-- Download Centre Card -->
      <!-- <div class="bg-gray-100 overflow-hidden download-center-card">
        <img src="assets/official-website/download-center.png" alt="Download Centre" class="w-full h-48 object-cover">
        <a class="further-topic-click-field hover:text-black" href="#">
          <h3 class="further-topic-sub-title">Download Centre</h3>
          <div class="further-topic-learn-more">
            <p>Learn more</p><img src="assets/official-website/arrow-right.png" class="arrow-image">
          </div>
        </a>
      </div> -->

    </div>
  </div>
</div>